import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { IPaginatedResult } from '@shared/interfaces/mailing/IPaginatedResult';
import { IItemBase, IResponsible } from '@shared/interfaces';
import { getPage } from '@shared/helpers/helpers';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICommunicationTemplate } from '@shared/interfaces/responsible/ICommunicationConfiguration';
import { ITimelineItem } from '@app/main/org-tree/org-communication-settings/timeline/timeline.component';

@Component({
    selector: 'app-mail-recipient-list',
    templateUrl: './mail-recipient-list.component.html',
    styleUrls: ['./mail-recipient-list.component.scss'],
    standalone: false
})
export class MailRecipientListComponent {
    nextPage: boolean;
    pageEvent: PageEvent = { pageIndex: 0, pageSize: 5, length: 0 };
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('recipientContainer') recipientContainer: ElementRef;
    paginatedData: IPaginatedResult<IMailRecipientItem>;
    loading = false;

    constructor(
        public dialogRef: MatDialogRef<MailRecipientListComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            recipients: IMailRecipientItem[];
            communication: ICommunicationTemplate;
            timelineItem: ITimelineItem;
        }
    ) {
        this.recipients = data.recipients;
    }

    private _recipients: IMailRecipientItem[];

    get recipients(): IMailRecipientItem[] {
        return this._recipients;
    }

    set recipients(val: IMailRecipientItem[]) {
        this._recipients = val;
        this.paginatedData = getPage(this.pageEvent, val);
    }

    get recipientLength(): number {
        return this.paginatedData?.totalItems || this.filteredRecipients?.length;
    }

    get totalItems(): number {
        return this.paginatedData?.totalItems;
    }

    get hasMore(): boolean {
        return this.paginatedData?.hasMore;
    }

    get filteredRecipients(): IMailRecipientItem[] {
        return this.recipients?.filter(e => !(e as IItemBase).filtered);
    }

    get pagedRecipients(): IMailRecipientItem[] {
        return this.filteredRecipients?.slice(
            this.pageEvent.pageIndex * this.pageEvent.pageSize,
            this.pageEvent.pageIndex * this.pageEvent.pageSize + this.pageEvent.pageSize
        );
    }

    async page(event: PageEvent) {
        this.nextPage = event.pageIndex > this.pageEvent.pageIndex;

        this.pageEvent = event;
        setTimeout(() => this.recipientContainer.nativeElement?.scrollTo({ top: 0 }), 100);
    }

    protected close(): void {
        this.dialogRef.close();
    }
}

export interface IMailRecipientItem {
    to: string[];
    cc: string[];
    bcc?: string[];
    organisation?: IResponsible;
}
